import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../_services/api/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);
  router = inject(Router);

  isLoading: boolean = true;
  isSuccess: boolean = false;
  errorMessage: string = '';
  token: string = '';
  userEmail: string = '';

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.userEmail = params['email'];
      
      if (this.token) {
        this.verifyEmail();
      } else {
        this.errorMessage = 'Token de vérification manquant.';
        this.isLoading = false;
      }
    });
  }

  verifyEmail(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.authService.verifyEmail(this.token).subscribe({
      next: (response) => {
        setTimeout(() => {
           this.isLoading = false;
           this.isSuccess = true;
        }, 2000);
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.isSuccess = false;
        
        if (error.status === 400) {
          this.errorMessage = 'Token de vérification invalide ou expiré.';
        } else if (error.status === 409) {
          this.errorMessage = 'Cette adresse email est déjà vérifiée.';
        } else {
          this.errorMessage = 'Une erreur est survenue lors de la vérification. Veuillez réessayer.';
        }
      }
    });
  }

  navigateToResend(): void {
    const queryParams: any = {};
    if (this.userEmail) {
      queryParams.email = this.userEmail;
    }
    this.router.navigate(['/resend-verification'], { queryParams });
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }
}